import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useUsers, UserTable } from 'features/users';
import HealthCheck from 'components/HealthCheck';
import ConfirmDialog from 'components/ConfirmDialog';

const UserListPage = () => {
  const { users, loading, error, removeUser } = useUsers();
  const { me } = useOutletContext();
  const [userToDelete, setUserToDelete] = useState(null);

  return (
    <div className="d-flex flex-column gap-4">
      <HealthCheck />

      <div className="gh-box">
        <div className="gh-box-header d-flex align-items-center justify-content-between">
          <span>
            <i className="bi bi-people me-2" aria-hidden="true"></i>
            User management
          </span>
        </div>

        {error && (
          <div className="px-3 pt-3">
            <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
              <i className="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
              {error}
            </div>
          </div>
        )}

        {loading ? (
          <div className="gh-box-body d-flex align-items-center gap-2 text-muted-gh">
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </div>
        ) : (
          <UserTable
            users={users}
            currentUserId={me && me.id}
            currentUserRole={me && me.role}
            onDelete={setUserToDelete}
          />
        )}
      </div>

      {userToDelete && (
        <ConfirmDialog
          title="Delete user"
          message={<>Delete user <strong>{userToDelete.username}</strong>? This action cannot be undone.</>}
          confirmLabel="Delete"
          danger
          onConfirm={async () => {
            await removeUser(userToDelete.id);
            setUserToDelete(null);
          }}
          onCancel={() => setUserToDelete(null)}
        />
      )}
    </div>
  );
};

export default UserListPage;
